import { useState } from 'react'
import { successSnack } from 'features'
import { useDispatch } from 'react-redux'

function useAbleStatusToggle({
  id,
  able = null,
  mutation,
  successMessage = '',
  successCallback,
  errorCallback,
}) {
  const [currentAbleStatus, setCurrentAbleStatus] = useState(able)
  const dispatch = useDispatch()

  const [updateAbleStatus, { isLoading }] = mutation()

  function toggleAbleStatus(able = currentAbleStatus) {
    const mutation = updateAbleStatus({
      id: id,
      able: !able,
    }).unwrap()
    mutation
      .then((response) => {
        if (successCallback) {
          let success = successCallback(response)
          if (success) {
            setCurrentAbleStatus(!able)
          }
        } else {
          dispatch(
            successSnack({
              message:
                successMessage +
                ' ' +
                (!currentAbleStatus ? 'habilitado' : 'deshabilitado'),
            })
          )
          return !currentAbleStatus
        }
      })
      .catch((error) => {
        if (errorCallback) {
          errorCallback(error)
        }
      })
  }

  return [toggleAbleStatus, { currentAbleStatus, isLoading }]
}

export default useAbleStatusToggle
